import React from "react";

import { LookupOrdersButton } from "../../../../../common/components/lookup-buttons/LookupOrdersButton";
import { useAssociateLookupOrders } from "./lookup-orders/useAssociateLookupOrders";

export const AssociateLookupOrdersButton = (): JSX.Element => {
    const { setContentFromLookupOrders } = useAssociateLookupOrders();

    return <LookupOrdersButton setContentFromLookupOrders={setContentFromLookupOrders} />;
};
